import React from 'react'
import { useHistory } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'
import { FirestoreClient } from 'loxamtraining-core'

import { Page, PageTitleBar, PageSection, FormSet } from '../partials'


interface PageAddProps {
	title: string,
	path: string,
	initialValues?: any
}


const PageAdd: React.FC<PageAddProps> = props => {
	const firestoreClient = new FirestoreClient()
	const history = useHistory()

	const handleSumit = (values: any, actions: any) => {
		return firestoreClient.add(props.path, values).then((id) => {
			history.push(`${props.path}/${id}`)
		})

		return new Promise(resolve => resolve())		
	}

	return (
		<Page>
			<PageTitleBar>
				<h1 className="page-title mr-sm-auto">{props.title}</h1> 
			</PageTitleBar>
			<PageSection>
				<Card>
					<CardBody>
						<FormSet handleSubmit={handleSumit} data={props.initialValues ? props.initialValues : {}} isLoading={false}>
							{ props.children }
						</FormSet>
					</CardBody>
				</Card>
			</PageSection>
		</Page>
	)
}


export default PageAdd